const PlatformKeyboardSpacer = (): null => null;

export default PlatformKeyboardSpacer;
